export default __webpack_public_path__ + "static/media/Sun.30e5ebb1.svg";